<template>
    <div v-if="carregado">
        <slot></slot>
    </div>
</template>
<script>
const merge = require('deepmerge')
import { formataUrlRedirecionamento } from '@/shared/common/functions/roteamento'

export default {
    props: {
        urlApi: {
            default: null
        },
        urlRetorno: {
            default: null
        },
        apiService: { 
            type: String,
            default: null
        }
    },
    computed: {
        url: function(){
            if(this.urlApi){
                return this.urlApi
            }
            if (this.apiService && this.$root[`$${this.apiService}`]) {
                return this.$route.fullPath.replaceAll(this.$urlBase + '/', '/')
            }
            return this.$route.fullPath
        },
        urlRetornoFormatada: function(){
            let url = ''
            if(this.urlRetorno){
                url = this.urlRetorno
            }else if(this.urlApi){
                url = this.urlApi
            }else{
                url = this.$route.fullPath
            }
            return url
                .replaceAll('&', '%26')
                .replaceAll('/', '%2F')
        }
    },
    data(){
        return {
            carregado: false,
            paginacao: {},
            parametros: '',
            ordenadoPor: null,
            ordenacaoDecrescente: false,
            situacaoBuscaAvancada: false,
        }
    },
    mounted(){
        const searchParams = new URLSearchParams(location.search).toString()
        if(searchParams){
            this.parametros = searchParams
        }
        const url = this.urlApi ? this.urlApi + (this.parametros ? '?' + this.parametros : '') : this.$route.fullPath
        this.listar(url)
        this.$emit('urlRetorno', this.urlRetornoFormatada);
    },
    watch: {
        '$route'(de, para) {
            if(de.query != para.query){
                const url = this.urlApi ? this.urlApi + (this.parametros ? '?' + this.parametros : '') : de.fullPath
                this.listar(url)
                // const urlRetorno = this.$route.fullPath
                // this.urlRetorno = urlRetorno
                this.$emit('urlRetorno', this.urlRetornoFormatada)
            }
        }
    },
    methods: {
        buscaApi() {
            if (this.apiService && this.$root[`$${this.apiService}`]) {
                return this.$root[`$${this.apiService}`]
            }
            return this.$api
        },
        limpaBuscaSimples(busca){
            if(!busca){
                this.atualizaUrl({}, false)
            }
        },
        validaParametros(parametros){
            const searchParams = new URLSearchParams(location.search)
            const entradas = {}
            for(const entrada of searchParams.entries()) {
                entradas[entrada[0]] = entrada[1]
            }
            const juncao = Object.assign(entradas, parametros)
            return juncao
        },
        atualizaUrl(parametros, juntar = true, url = this.$route.path){
            let _parametros = Object.assign({}, parametros)
            if(juntar){
                _parametros = this.validaParametros(_parametros)
            }
            Object.keys(_parametros).map(parametro => {
                if(_parametros[parametro] && typeof _parametros[parametro] === 'object') {
                    Object.keys(_parametros[parametro]).map(campo => {
                        _parametros[parametro + '['+campo+']'] = 
                            _parametros[parametro][campo]
                    })
                    delete _parametros[parametro]
                }
            })
            this.parametros = new URLSearchParams(_parametros).toString()
            this.$router.push({
                path: url, 
                query: _parametros
            }).catch(()=>{})
        },
        atualiza(){
            this.listar(this.url)
        },
        async listar(url){
            this.carregado = false
            this.$loading.show()
            const retorno = await this.buscaApi().cGet(url)

            if (retorno.status == 'error' && retorno.error) {
                this.$notify.error(retorno.error)
                if (retorno.redirect){
                    this.$router.push(formataUrlRedirecionamento(retorno.redirect))
                } else {
                    this.$router.push(this.$route.query.retorno || this.$urlBase + '/inicio')
                }
                return
            }

            if(retorno.status == 'success'){
                if(retorno.meta){
                    this.paginacao = retorno.meta
                }
                if(retorno.meta.order){
                    if(typeof retorno.meta.order == 'string'){
                        retorno.meta.order = { [retorno.meta.order]: 'asc' }
                    }
                    for(let ordenadoPor in retorno.meta.order){
                        this.ordenadoPor = ordenadoPor
                        this.ordenacaoDecrescente = 
                            retorno.meta.order[ordenadoPor] == 'desc'
                    }
                }
                if(retorno.data.buscaSimples){
                    this.$parent.buscaSimples = retorno.data.buscaSimples
                }
                if(retorno.data.buscaAvancada){
                    this.$parent.buscaAvancada = merge(
                        this.$parent.buscaAvancada,
                        retorno.data.buscaAvancada, 
                    )
                    this.$parent.buscaAvancada['atualizado_em'] = Date.now()
                }
                this.situacaoBuscaAvancada = retorno.data.situacaoBuscaAvancada
            }
            if(!this.carregado){
                this.$emit('carregado', true)
            }
            this.carregado = true
            this.$emit('lista', retorno)
            setTimeout(() => {
                this.$loading.hide()
            }, 500)
            return retorno
        }
    },
}
</script>